import type {
    IsoAndUnixTimestamp} from "@@/shared/date-time/iso-and-unix";
import {
    isoAndUnixZodSchema,
    nowIsoAndUnix,
} from "@@/shared/date-time/iso-and-unix";
import { idZodSchema } from "@@/shared/id";
import type {
    ProviderId} from "@@/shared/providers/provider-id";
import {
    providerIdZodSchema,
} from "@@/shared/providers/provider-id";
import type { SectionGroupId } from "@@/shared/section-groups/section-group";
import type {
    RequiredTranslatable} from "@@/shared/translations/translation";
import {
    requiredTranslatableZodSchema,
} from "@@/shared/translations/translation";
import { generateId } from "@@/utilities/generate-id";
import type { Except } from "type-fest";
import { z } from "zod";
import type { SectionId } from "../section";

type SectionAddCommand = {
    readonly _id: string;
    readonly _type: "SECTION_ADD_COMMAND";
    readonly _createdAt: IsoAndUnixTimestamp;
    readonly providerId: ProviderId;
    readonly sectionGroupId: SectionGroupId;
    readonly sectionId: SectionId;
    readonly title: RequiredTranslatable;
};

type FactoryParams = Except<SectionAddCommand, "_id" | "_type" | "_createdAt">;
const sectionAddCommandFactory = (params: FactoryParams) => {
    const sectionAddCommand: SectionAddCommand = {
        ...params,
        _id: generateId({ prefix: "section_add_command__" }),
        _type: "SECTION_ADD_COMMAND",
        _createdAt: nowIsoAndUnix(),
    };
    return sectionAddCommand;
};

const sectionAddCommandZodSchema: z.ZodSchema<SectionAddCommand> = z.object({
    _id: idZodSchema,
    _type: z.literal("SECTION_ADD_COMMAND"),
    _createdAt: isoAndUnixZodSchema,
    providerId: providerIdZodSchema,
    sectionGroupId: idZodSchema,
    sectionId: idZodSchema,
    title: requiredTranslatableZodSchema,
});

export { sectionAddCommandFactory, sectionAddCommandZodSchema };
export type {
    FactoryParams as CreateSectionAddCommandParams,
    SectionAddCommand,
};
